/* ═══════════════════════════════
   IQONE · nowy wzór 1:1 (prototyp CLAUDEstrona) na Shopify
   Shell (nav/stopka/kafle/PDP) jest SSR w Liquid — JS tylko animacje + koszyk.

   21.09.2026 — WIELOJĘZYCZNOŚĆ:
   Pliki .js nie przechodzą przez Liquid, więc nie ma tu filtra | t. Wszystkie
   teksty widoczne dla klienta czytamy przez T('klucz', 'polski fallback'),
   a słownik dostarcza snippets/iqn-i18n.liquid (renderowany w iqn-nav.liquid,
   czyli zawsze PRZED tym plikiem — ten ma defer).
   Jeśli dopisujesz tu nowy napis dla klienta: dodaj klucz w locales/pl.default.json
   i locales/en.json, wystaw go w iqn-i18n.liquid i użyj T(). Nie wpisuj tekstu wprost.
   ═══════════════════════════════ */
(function () {
'use strict';

/* słownik z Liquida; fallback polski, żeby sklep nigdy nie pokazał pustego miejsca */
const T = (k, fb) => ((window.IQN && window.IQN.t && window.IQN.t[k]) || fb);
const RT = (k, fb) => ((window.IQN && window.IQN.routes && window.IQN.routes[k]) || fb);

const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const lerp = (a, b, t) => a + (b - a) * t;
const clamp = (v, mn, mx) => Math.min(mx, Math.max(mn, v));
/* ─────────── CURSOR (termiczny) ─────────── */
function initCursor() {
  if (window.matchMedia('(hover: none)').matches) return;
  const cur = document.createElement('div');
  cur.className = 'cursor';
  cur.innerHTML = '<div class="cursor-ring"></div><div class="cursor-dot"></div>';
  document.body.appendChild(cur);
  let x = -100, y = -100, cx = -100, cy = -100;
  window.addEventListener('mousemove', e => { x = e.clientX; y = e.clientY; });
  (function loop() {
    cx = lerp(cx, x, 0.2); cy = lerp(cy, y, 0.2);
    cur.style.transform = `translate(${cx}px, ${cy}px)`;
    requestAnimationFrame(loop);
  })();
  window._cursorEl = cur;
}
function bindHotCursor() {
  const cur = window._cursorEl;
  if (!cur) return;
  document.querySelectorAll('a, button, [data-hot]').forEach(el => {
    el.addEventListener('mouseenter', () => cur.classList.add('hot'));
    el.addEventListener('mouseleave', () => cur.classList.remove('hot'));
  });
}

/* ─────────── REVEAL ─────────── */
function initReveal() {
  const io = new IntersectionObserver(es => {
    es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
}

/* ─────────── FAQ (accordion) ─────────── */
function initFAQ() {
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    const a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.addEventListener('click', () => {
      const open = item.classList.toggle('open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
    });
  });
}

/* ─────────── COUNTERS ─────────── */
function initCounters() {
  const io = new IntersectionObserver(es => {
    es.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target, target = parseFloat(el.dataset.target), D = 1500, s = performance.now();
      (function tick(now) {
        const t = clamp((now - s) / D, 0, 1), k = 1 - Math.pow(1 - t, 4);
        el.textContent = Math.round(target * k);
        if (t < 1) requestAnimationFrame(tick);
      })(s);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.counter').forEach(el => io.observe(el));
}

/* ─────────── HERO ORB (index) ─────────── */
function initHeroOrb() {
  const canvas = document.getElementById('heroCanvas');
  if (!canvas || prefersReduced) return;
  const ctx = canvas.getContext('2d');
  let W, H, DPR, cxs, cys, R, mx = .5, my = .5, inside = false, rotY = 0;
  const N = 900, pts = [], golden = Math.PI * (3 - Math.sqrt(5));
  for (let i = 0; i < N; i++) {
    const yy = 1 - (i / (N - 1)) * 2, rad = Math.sqrt(1 - yy * yy), th = golden * i;
    pts.push({ x: Math.cos(th) * rad, y: yy, z: Math.sin(th) * rad, heat: 0, s: .5 + Math.random() });
  }
  function resize() {
    DPR = Math.min(devicePixelRatio || 1, 2);
    W = canvas.clientWidth; H = canvas.clientHeight;
    canvas.width = W * DPR; canvas.height = H * DPR; ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    cxs = W * 0.72; cys = H * 0.5; R = Math.min(W, H) * 0.33;
  }
  resize(); window.addEventListener('resize', resize);
  canvas.addEventListener('mousemove', e => { const r = canvas.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width; my = (e.clientY - r.top) / r.height; inside = true; });
  canvas.addEventListener('mouseleave', () => inside = false);
  (function frame() {
    ctx.clearRect(0, 0, W, H);
    rotY += 0.0024 + (inside ? Math.abs(mx - .5) * 0.006 : 0);
    const sY = Math.sin(rotY), cY = Math.cos(rotY), sX = Math.sin(.3), cX = Math.cos(.3);
    const mpx = mx * W, mpy = my * H;
    for (const p of pts) {
      let x1 = p.x * cY + p.z * sY, z1 = -p.x * sY + p.z * cY;
      let y1 = p.y * cX - z1 * sX, z2 = p.y * sX + z1 * cX;
      const persp = 1 / (1.6 - z2 * .55), sx = cxs + x1 * R * persp, sy = cys + y1 * R * persp;
      if (inside) { const d = Math.hypot(sx - mpx, sy - mpy); if (d < 120) p.heat = clamp(p.heat + (1 - d / 120) * .14, 0, 1); }
      p.heat = Math.max(0, p.heat - .012);
      const depth = (z2 + 1) / 2, a = .1 + depth * .7, h = p.heat;
      const r = Math.round(lerp(200, 255, h)), g = Math.round(lerp(207, 90, h)), b = Math.round(lerp(203, 45, h));
      ctx.beginPath(); ctx.fillStyle = `rgba(${r},${g},${b},${a * (.5 + h * .5)})`;
      ctx.arc(sx, sy, p.s * persp * (1 + h * 1.5), 0, 6.29); ctx.fill();
    }
    requestAnimationFrame(frame);
  })();
}

/* ─────────── SIMULATOR (technologia) ─────────── */
function initSim() {
  const canvas = document.getElementById('simCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const slider = document.getElementById('simSlider');
  const ambEl = document.getElementById('simAmb');
  const stateEl = document.getElementById('simState');
  const dotEl = document.getElementById('simDot');
  const descEl = document.getElementById('simDesc');
  let ambient = parseFloat(slider.value), disp = ambient, W, H, DPR, t = 0;
  const COLS = 14, ROWS = 9, caps = [];
  for (let r = 0; r < ROWS; r++) for (let c = 0; c < COLS; c++) caps.push({ c, r, ph: Math.random() * 6.28, st: 0 });
  function resize() { DPR = Math.min(devicePixelRatio || 1, 2); W = canvas.clientWidth; H = canvas.clientHeight; canvas.width = W * DPR; canvas.height = H * DPR; ctx.setTransform(DPR, 0, 0, DPR, 0, 0); }
  resize(); window.addEventListener('resize', resize);
  const STATES = {
    cold: { t: T('sim_cold_t', 'Oddają ciepło'), d: '#ff8a50', desc: T('sim_cold_d', 'Zimno. Kapsuły PCM krzepną i uwalniają zmagazynowaną energię. Materiał staje się mikrogrzejnikiem przy skórze.') },
    ok:   { t: T('sim_ok_t', 'Stan komfortu'), d: '#37c07a', desc: T('sim_ok_d', 'Kapsuły w równowadze. Materiał utrzymuje mikroklimat bez grama nadmiaru ciepła i chłodu.') },
    hot:  { t: T('sim_hot_t', 'Pochłaniają ciepło'), d: '#c8cfcb', desc: T('sim_hot_d', 'Gorąco. Kapsuły topią się i absorbują nadmiar ciepła z ciała, zanim gruczoły potowe dostaną sygnał.') }
  };
  let last = '';
  function setState() {
    const k = ambient < 8 ? 'cold' : ambient > 24 ? 'hot' : 'ok';
    if (k === last) return; last = k;
    stateEl.textContent = STATES[k].t; dotEl.style.background = STATES[k].d; descEl.textContent = STATES[k].desc;
  }
  slider.addEventListener('input', () => { ambient = parseFloat(slider.value); setState(); });
  setState();
  (function frame() {
    t += .016; disp = lerp(disp, ambient, .08); ambEl.textContent = Math.round(disp) + '°';
    ctx.clearRect(0, 0, W, H);
    const g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#12151b'); g.addColorStop(1, '#0b0d10'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    const target = ambient < 8 ? -1 : ambient > 24 ? 1 : 0;
    const pX = W * .1, pY = H * .14, gw = (W - pX * 2) / (COLS - 1), gh = (H - pY * 2) / (ROWS - 1), bR = Math.min(gw, gh) * .26;
    for (const cap of caps) {
      cap.st = lerp(cap.st, target, .04);
      const x = pX + cap.c * gw + Math.sin(cap.ph * 3) * 3, y = pY + cap.r * gh + Math.sin(t * 1.4 + cap.ph) * 2.2, s = cap.st;
      let cr, cg, cb;
      if (s < 0) { const k = -s; cr = lerp(120, 255, k); cg = lerp(200, 138, k); cb = lerp(140, 80, k); }
      else { const k = s; cr = lerp(120, 200, k); cg = lerp(200, 207, k); cb = lerp(140, 203, k); }
      const rad = bR * (1 + Math.sin(t * 2.2 + cap.ph) * .12) * (1 + Math.abs(s) * .25);
      ctx.beginPath(); ctx.fillStyle = `rgba(${cr|0},${cg|0},${cb|0},${.08 + Math.abs(s) * .1})`; ctx.arc(x, y, rad * 2.4, 0, 6.29); ctx.fill();
      ctx.beginPath(); ctx.fillStyle = `rgba(${cr|0},${cg|0},${cb|0},${.5 + Math.abs(s) * .4})`; ctx.arc(x, y, rad, 0, 6.29); ctx.fill();
    }
    requestAnimationFrame(frame);
  })();
}

/* ─────────── VIDEO (mute toggle) ─────────── */
function initVideo() {
  document.querySelectorAll('[data-vbmute]').forEach(btn => {
    const vid = (btn.closest('.videoband') || btn.closest('.sh-panel') || document).querySelector('video');
    if (!vid) return;
    btn.addEventListener('click', () => {
      vid.muted = !vid.muted;
      btn.textContent = vid.muted ? '🔇' : '🔊';
      if (!vid.muted) vid.play().catch(() => {});
    });
  });
}
/* ─────────── TYPEWRITER (jak w guerrilla) ─────────── */
function initTypewriter() {
  const els = [...document.querySelectorAll('[data-type]')];
  if (!els.length) return;
  els.forEach(el => {
    el.dataset._full = el.textContent.trim();
    el.textContent = '';
    const txt = document.createTextNode('');
    const cur = document.createElement('span');
    cur.className = 'tw-cursor';
    el.appendChild(txt);
    el.appendChild(cur);
    el._txt = txt;
  });
  function typeEl(el) {
    const full = el.dataset._full;
    if (prefersReduced) { el._txt.textContent = full; el.classList.add('tw-done'); return; }
    let i = 0;
    (function step() {
      el._txt.textContent = full.slice(0, i);
      if (i < full.length) { i++; setTimeout(step, 34 + Math.random() * 26); }
      else el.classList.add('tw-done');
    })();
  }
  // sekwencyjnie: panele wpisują się jeden po drugim
  let idx = 0;
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const delay = prefersReduced ? 0 : 300 * (idx++);
      setTimeout(() => typeEl(e.target), delay);
    });
  }, { threshold: 0.3 });
  els.forEach(el => io.observe(el));
}
/* ─────────── MATERIAŁY · auto-cykl podejść ─────────── */
function initMatCycle() {
  const wrap = document.getElementById('matSlides');
  if (!wrap) return;
  const slides = [...wrap.querySelectorAll('.mat-slide')];
  const dotsWrap = document.getElementById('matDots');
  let idx = 0, timer = null;
  const DELAY = 4500;

  slides.forEach((_, i) => {
    const b = document.createElement('button');
    b.setAttribute('aria-label', T('approach', 'Podejście') + ' ' + (i + 1));
    b.addEventListener('click', () => { show(i); restart(); });
    dotsWrap.appendChild(b);
  });
  const dots = [...dotsWrap.children];

  function show(i) {
    idx = (i + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('on', k === idx));
    dots.forEach((d, k) => d.classList.toggle('on', k === idx));
  }
  function next() { show(idx + 1); }
  function restart() { clearInterval(timer); timer = setInterval(next, DELAY); }

  // start od najlepszego wyboru? Nie, pokaż po kolei od 0.
  show(0);
  if (!prefersReduced) restart();

  // pauza, gdy scena poza ekranem
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (prefersReduced) return;
    if (e.isIntersecting) restart(); else clearInterval(timer);
  }), { threshold: 0.2 });
  io.observe(wrap);
}
/* ─────────── TECHNOLOGIA · ruchoma kulka + kapsułki ─────────── */
function initTechSphere() {
  const canvas = document.getElementById('techSphere');
  if (!canvas) return;
  // kapsułki po bokach
  const cap = (fill, color) => `<span class="tp-cap${fill ? ' fill' : ''}"></span>`;
  const abs = document.getElementById('capsAbsorb');
  const rel = document.getElementById('capsRelease');
  if (abs) abs.innerHTML = cap(1) + cap(1) + cap(1) + '<i class="tp-arrow">→</i>' + cap(0) + cap(0);
  if (rel) rel.innerHTML = cap(0) + cap(0) + '<i class="tp-arrow">→</i>' + cap(0) + cap(1) + cap(1) + cap(1);
  if (prefersReduced) return;

  const ctx = canvas.getContext('2d');
  let W, H, DPR, cx, cy, R, rotY = 0;
  const N = 540, pts = [], golden = Math.PI * (3 - Math.sqrt(5));
  for (let i = 0; i < N; i++) {
    const yy = 1 - (i / (N - 1)) * 2, rad = Math.sqrt(1 - yy * yy), th = golden * i;
    pts.push({ x: Math.cos(th) * rad, y: yy, z: Math.sin(th) * rad, s: .5 + Math.random(), tw: Math.random() * 6.28 });
  }
  function resize() {
    DPR = Math.min(devicePixelRatio || 1, 2);
    W = canvas.clientWidth; H = canvas.clientHeight;
    canvas.width = W * DPR; canvas.height = H * DPR; ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    cx = W / 2; cy = H / 2; R = Math.min(W, H) * 0.42;
  }
  resize(); window.addEventListener('resize', resize);
  let t = 0;
  (function frame() {
    t += 0.016; rotY += 0.006;
    ctx.clearRect(0, 0, W, H);
    const halo = ctx.createRadialGradient(cx, cy, R * 0.15, cx, cy, R * 1.45);
    halo.addColorStop(0, 'rgba(196,200,194,.13)'); halo.addColorStop(1, 'rgba(196,200,194,0)');
    ctx.fillStyle = halo; ctx.beginPath(); ctx.arc(cx, cy, R * 1.45, 0, 6.29); ctx.fill();
    const sY = Math.sin(rotY), cY = Math.cos(rotY), sX = Math.sin(.34), cX = Math.cos(.34);
    for (const p of pts) {
      const x1 = p.x * cY + p.z * sY, z1 = -p.x * sY + p.z * cY;
      const y1 = p.y * cX - z1 * sX, z2 = p.y * sX + z1 * cX;
      const persp = 1 / (1.6 - z2 * .5), sx = cx + x1 * R * persp, sy = cy + y1 * R * persp;
      const depth = (z2 + 1) / 2, a = (.12 + depth * .7) * (.7 + 0.3 * Math.sin(t * 2 + p.tw));
      const k = (x1 + 1) / 2; // lewa pomarańczowy · prawa niebieski
      const r = Math.round(lerp(255, 200, k)), g = Math.round(lerp(90, 207, k)), b = Math.round(lerp(45, 203, k));
      ctx.beginPath(); ctx.fillStyle = `rgba(${r},${g},${b},${a})`;
      ctx.arc(sx, sy, p.s * persp * 1.35, 0, 6.29); ctx.fill();
    }
    requestAnimationFrame(frame);
  })();
}

/* ═══════════════════ warstwa Shopify (SSR + realny koszyk) ═══════════════════ */

/* SPLIT HERO · slajdy z assetów motywu (bez probowania plików) */
function initSplitSlideshow() {
  const slots = [...document.querySelectorAll('.sh-slides')];
  const pool = ((window.IQN && window.IQN.hero) || []).slice();
  if (!slots.length || !pool.length) return;
  slots.forEach(slot => {
    slot.innerHTML = '';
    pool.forEach(src => { const im = new Image(); im.src = src; im.alt = ''; slot.appendChild(im); });
  });
  const offset = slots.length > 1 ? Math.max(1, Math.floor(pool.length / 2)) : 0;
  const idx = slots.map((_, si) => (si * offset) % pool.length);
  function paint() {
    slots.forEach((slot, si) => [...slot.children].forEach((im, k) => im.classList.toggle('on', k === idx[si])));
  }
  paint();
  if (pool.length > 1 && !prefersReduced) {
    setInterval(() => { for (let si = 0; si < slots.length; si++) idx[si] = (idx[si] + 1) % pool.length; paint(); }, 7000);
  }
}

/* BURGER */
function initBurger() {
  const burger = document.getElementById('burger'), menu = document.getElementById('mobileMenu');
  if (!burger || !menu) return;
  burger.addEventListener('click', () => { burger.classList.toggle('open'); menu.classList.toggle('open'); });
}

/* KOSZYK · realny Shopify AJAX Cart */
const FREE_SHIP = 39900; // w groszach
/* Kwoty: waluta sklepu się NIE zmienia (PLN), zmienia się tylko zapis —
   „349,00 zł” po polsku, „PLN 349.00” po angielsku. */
function money(c) {
  const tag = (window.IQN && window.IQN.localeTag) || 'pl-PL';
  const cur = (window.IQN && window.IQN.currency) || 'PLN';
  try {
    return new Intl.NumberFormat(tag, { style: 'currency', currency: cur }).format(c / 100);
  } catch (e) {
    return (c / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  }
}
function openCart() { document.getElementById('cartDrawer')?.classList.add('open'); document.getElementById('cartOverlay')?.classList.add('open'); document.body.style.overflow = 'hidden'; }
function closeCart() { document.getElementById('cartDrawer')?.classList.remove('open'); document.getElementById('cartOverlay')?.classList.remove('open'); document.body.style.overflow = ''; }

/* Shopify rozbija wiersze koszyka, gdy rabat automatyczny obejmuje część sztuk.
   Dlatego widok grupujemy po wariancie, a ilość ustawiamy pozycyjnie. */
function promoTxt() { return T('promo_txt', 'Druga (tańsza) sztuka &minus;15% &middot; rabat dolicza się automatycznie'); }
function groupCart(cart) {
  const out = [], map = {};
  cart.items.forEach(it => {
    const k = String(it.variant_id);
    if (!map[k]) {
      map[k] = {
        variant_id: it.variant_id, product_title: it.product_title, variant_title: it.variant_title,
        url: it.url, image: it.image, price: it.price,
        quantity: 0, original: 0, final: 0, discounts: []
      };
      out.push(map[k]);
    }
    const g = map[k];
    g.quantity += it.quantity;
    g.original += it.original_line_price;
    g.final += it.final_line_price;
    (it.line_level_discount_allocations || []).forEach(d => {
      const t = d.discount_application && d.discount_application.title;
      if (t && d.amount > 0 && g.discounts.indexOf(t) < 0) g.discounts.push(t);
    });
  });
  return out;
}
function renderCart(cart) {
  document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  const body = document.getElementById('cartBody'), foot = document.getElementById('cartFoot');
  if (!body || !foot) return;
  const rows = groupCart(cart);
  if (!rows.length) body.innerHTML = `<div class="cart-empty">${T('cart_empty', 'Twój koszyk jest pusty.')}</div>`;
  else body.innerHTML = rows.map(g => {
    const img = g.image ? `<img src="${g.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2')}" alt="">` : '';
    const meta = (g.variant_title && g.variant_title !== 'Default Title' ? T('size_prefix', 'Rozmiar: ') + g.variant_title + ' · ' : '') + money(g.price);
    const saved = g.original - g.final;
    const sum = saved > 0
      ? `<s>${money(g.original)}</s><b>${money(g.final)}</b>`
      : `<b>${money(g.final)}</b>`;
    const tag = saved > 0 ? `<div class="cart-item-promo">${g.discounts[0] || T('discount', 'Rabat')} &minus;${money(saved)}</div>` : '';
    return `<div class="cart-item">
      <div class="cart-item-img">${img}</div>
      <div class="cart-item-info">
        <div class="cart-item-name">${g.product_title}</div>
        <div class="cart-item-meta">${meta}</div>
        ${tag}
        <div class="cart-qty">
          <button data-q="-" data-v="${g.variant_id}" aria-label="${T('less', 'Mniej')}">−</button><span data-qv="${g.variant_id}">${g.quantity}</span><button data-q="+" data-v="${g.variant_id}" aria-label="${T('more', 'Więcej')}">+</button>
          <button class="cart-rm" data-rm="${g.variant_id}">${T('remove', 'Usuń')}</button>
        </div>
      </div>
      <div class="cart-item-sum">${sum}</div></div>`;
  }).join('');
  const brakuje = Math.max(0, FREE_SHIP - cart.total_price);
  const disc = cart.total_discount || 0;
  const discTitle = (rows.find(g => g.discounts.length) || {}).discounts;
  const oneLeft = cart.item_count === 1;
  foot.innerHTML = `
    ${cart.item_count ? `<div class="cart-promo${disc > 0 ? ' on' : ''}">${disc > 0 ? '✓ ' + (discTitle && discTitle[0] ? discTitle[0] : T('discount_applied', 'Rabat naliczony')) : (oneLeft ? T('promo_add_second', 'Dodaj drugą sztukę: ') + promoTxt() : promoTxt())}</div>` : ''}
    <label class="cart-terms"><input type="checkbox" id="cartTerms"> <span>${T('terms_html', 'Zapoznałem/am się z <a href="/policies/terms-of-service" target="_blank">Regulaminem</a> oraz <a href="/policies/privacy-policy" target="_blank">Polityką prywatności</a> i akceptuję ich postanowienia. Przyjmuję do wiadomości, że przysługuje mi prawo odstąpienia od umowy w terminie 30 dni.')}</span></label>
    ${disc > 0 ? `<div class="cart-total sub"><span>${T('subtotal', 'Wartość')}</span><span>${money(cart.total_price + disc)}</span></div>
    <div class="cart-total disc"><span>${T('discount_label', 'Rabat')}</span><span>&minus;${money(disc)}</span></div>` : ''}
    <div class="cart-total"><span>${T('total', 'Suma')}</span><b>${money(cart.total_price)}</b></div>
    <button class="cart-checkout" id="cartCheckout">${T('checkout', 'Zamówienie')}</button>
    <div class="cart-ship">${brakuje > 0 ? T('free_ship_missing', 'Darmowa dostawa od 399 zł · brakuje ') + money(brakuje) : T('free_ship_have', 'Masz darmową dostawę ✓')}</div>`;
  body.querySelectorAll('[data-q]').forEach(b => b.addEventListener('click', () => {
    if (b._busy) return;
    const g = rows.find(x => String(x.variant_id) === b.dataset.v); if (!g) return;
    const next = g.quantity + (b.dataset.q === '+' ? 1 : -1);
    b._busy = true;
    const cell = body.querySelector('[data-qv="' + b.dataset.v + '"]');
    if (cell && next > 0) cell.textContent = next;
    setVariantTotal(b.dataset.v, next).then(renderCart);
  }));
  body.querySelectorAll('[data-rm]').forEach(b => b.addEventListener('click', () => setVariantTotal(b.dataset.rm, 0).then(renderCart)));
  const chk = document.getElementById('cartCheckout'), terms = document.getElementById('cartTerms');
  if (chk) chk.addEventListener('click', () => {
    if (!cart.item_count) return;
    if (!terms.checked) { terms.closest('.cart-terms').classList.add('req'); setTimeout(() => terms.closest('.cart-terms').classList.remove('req'), 800); return; }
    window.location.href = RT('checkout', '/checkout');
  });
}
function refreshCart() { return fetch('/cart.js').then(r => r.json()).then(renderCart); }
/* Ustawia ŁĄCZNĄ liczbę sztuk wariantu. Klucze wierszy zmieniają się przy rabatach,
   więc aktualizujemy pozycyjnie: pierwszy wiersz wariantu = total, pozostałe = 0. */
function setVariantTotal(variantId, total) {
  const vid = String(variantId);
  return fetch('/cart.js').then(r => r.json()).then(cart => {
    let first = -1;
    const updates = cart.items.map((it, i) => {
      if (String(it.variant_id) === vid) { if (first < 0) { first = i; } return 0; }
      return it.quantity;
    });
    if (first < 0) return cart;
    updates[first] = Math.max(0, total);
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).then(r => r.json());
  });
}
function addVariant(id, btn, qty) {
  if (!id) return Promise.resolve();
  const n = Math.max(1, parseInt(qty, 10) || 1);
  const vid = String(parseInt(id, 10));
  const fail = () => { if (btn) { const t = btn.textContent; btn.textContent = '✕'; setTimeout(() => btn.textContent = t, 1200); } };
  return fetch('/cart.js').then(r => r.json()).then(cart => {
    const have = cart.items.filter(it => String(it.variant_id) === vid).reduce((a, it) => a + it.quantity, 0);
    /* wariant już w koszyku → podnosimy ilość zamiast dodawać kolejny wiersz */
    if (have > 0) return setVariantTotal(vid, have + n);
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: n }] })
    }).then(r => { if (!r.ok) { fail(); return null; } return r.json().then(() => fetch('/cart.js').then(x => x.json())); });
  }).then(cart => { if (!cart) return; renderCart(cart); openCart(); }, fail);
}
function initCart() {
  document.getElementById('cartOverlay')?.addEventListener('click', closeCart);
  document.getElementById('cartClose')?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  document.querySelectorAll('[data-add-variant]').forEach(btn => {
    if (btn._b) return; btn._b = true;
    btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); addVariant(btn.dataset.addVariant, btn); });
  });
  /* strona /cart — wiersze są SSR, ilość ustawiamy po wariancie */
  document.querySelectorAll('[data-vqty]').forEach(btn => {
    if (btn._q) return; btn._q = true;
    btn.addEventListener('click', e => {
      e.preventDefault();
      btn.disabled = true;
      setVariantTotal(btn.dataset.vqty, Math.max(0, parseInt(btn.dataset.q, 10) || 0)).then(() => window.location.reload());
    });
  });
  if (document.getElementById('cartDrawer')) refreshCart();
}

/* SKLEP · filtry + klik w kartę (kafle są SSR z Shopify) */
function initShopFilters() {
  const inv = document.getElementById('inventory');
  if (!inv) return;

  function apply(cat) {
    document.querySelectorAll('.filter').forEach(x => {
      x.classList.toggle('active', x.dataset.filter === cat);
    });
    inv.querySelectorAll('.prod').forEach(p => {
      p.style.display = (cat === 'all' || (p.dataset.cat || '').split(' ').includes(cat)) ? '' : 'none';
    });
  }

  document.querySelectorAll('.filter').forEach(f => f.addEventListener('click', () => {
    apply(f.dataset.filter);
    /* zapisujemy wybór w adresie, żeby dało się go podlinkować i odświeżyć */
    try {
      const u = new URL(window.location.href);
      if (f.dataset.filter === 'all') { u.searchParams.delete('f'); } else { u.searchParams.set('f', f.dataset.filter); }
      history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
  }));

  /* wejście z linku w stopce / menu: /collections/all?f=work */
  try {
    const want = new URLSearchParams(window.location.search).get('f');
    if (want && document.querySelector('.filter[data-filter="' + want.replace(/[^a-z]/g, '') + '"]')) apply(want);
  } catch (e) {}

  inv.querySelectorAll('.prod[data-href]').forEach(card => {
    card.style.cursor = 'pointer';
    card.addEventListener('click', e => {
      /* własne linki na kafelku (przycisk, wartości karty podarunkowej) mają pierwszeństwo */
      if (e.target.closest('.prod-add') || e.target.closest('.prod-denom')) return;
      location.href = card.dataset.href;
    });
  });
}

/* PRODUKT · rozmiary → warianty, akordeon, ulubione (DOM jest SSR z Liquid) */
function initPDP() {
  const root = document.getElementById('productRoot');
  if (!root) return;
  const add = document.getElementById('pAdd');
  const sizesWrap = document.getElementById('pSizes');
  const btns = [...root.querySelectorAll('.pp-size')];
  const priceEl = root.querySelector('.pp-price');
  let chosen = btns.length === 1 ? btns[0] : null;
  if (chosen) chosen.classList.add('on');
  btns.forEach(b => b.addEventListener('click', () => {
    if (b.dataset.soldOut === 'true') return;
    btns.forEach(x => x.classList.remove('on'));
    b.classList.add('on'); chosen = b;
    if (priceEl && b.dataset.price) priceEl.firstChild.textContent = b.dataset.price + ' ';
    const u = new URL(location.href); u.searchParams.set('variant', b.dataset.variant); history.replaceState({}, '', u);
  }));
  add?.addEventListener('click', () => {
    if (!chosen) { sizesWrap.classList.remove('shake'); void sizesWrap.offsetWidth; sizesWrap.classList.add('shake'); return; }
    addVariant(chosen.dataset.variant, add);
  });
  const wish = document.getElementById('pWish');
  wish?.addEventListener('click', () => { wish.classList.toggle('on'); wish.textContent = wish.classList.contains('on') ? '♥' : '♡'; });
  document.querySelectorAll('.pp-acc-h').forEach(h => h.addEventListener('click', () => {
    const it = h.closest('.pp-acc-item'); it.classList.toggle('open');
    h.querySelector('i').textContent = it.classList.contains('open') ? '−' : '+';
  }));
}

/* BOOT */
document.addEventListener('DOMContentLoaded', () => {
  initCursor();
  bindHotCursor();
  initReveal();
  initCounters();
  initHeroOrb();
  initSim();
  initVideo();
  initSplitSlideshow();
  initTypewriter();
  initMatCycle();
  initTechSphere();
  initFAQ();
  initBurger();
  initShopFilters();
  initPDP();
  initCart();
});

})();